import { Pipe, PipeTransform } from '@angular/core';

import { StatusWnioskuODodatkoweSwiadczenie } from '@interfaces/wnioski/platforma-administratora/enums/status-wniosku-o-dodatkowe-swiadczenie.enum';

@Pipe({
  name: 'statusWnioskuODodatkoweSwiadczenie',
})
export class StatusWnioskuODodatkoweSwiadczeniePipe implements PipeTransform {
  transform(value: StatusWnioskuODodatkoweSwiadczenie): string {
    const { Zlozony, Akceptacja, BrakAkceptacji } = StatusWnioskuODodatkoweSwiadczenie;

    switch (value) {
      case Zlozony:
        return 'bg-warning';
      case Akceptacja:
        return 'bg-success';
      case BrakAkceptacji:
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
}
